"use client";

import { useState, useMemo } from "react";
import ProductsHeader from "./ProductsHeader";
import FilterSidebar, { FilterState } from "./FilterSidebar";
import ProductGrid, { Product } from "./ProductGrid";
import BundleBanner from "./BundleBanner";

const ALL_PRODUCTS: Product[] = [
{
  id: "p1",
  title: "ABC Wonderland Coloring Book",
  subtitle: "Alphabet + Animals | 52 Pages",
  category: "alphabet",
  price: 12.99,
  originalPrice: 18.99,
  rating: 4.9,
  reviews: 842,
  tag: "BESTSELLER",
  tagColor: "#F4C842",
  ageRange: "Ages 2–5",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ff246854-1771258627354.png",
  alt: "ABC Wonderland coloring book featuring illustrated alphabet letters with animals for toddlers aged 2 to 5",
  inStock: true,
  isBestseller: true
},
{
  id: "p2",
  title: "123 Rainbow Numbers",
  subtitle: "Count & Color | 48 Pages",
  category: "numbers",
  price: 10.99,
  originalPrice: 15.99,
  rating: 5.0,
  reviews: 1203,
  tag: "TOP RATED",
  tagColor: "#A8DADC",
  ageRange: "Ages 3–6",
  image: "https://images.unsplash.com/photo-1680378722245-be13952760d4",
  alt: "123 Rainbow Numbers counting and coloring activity book for preschool children ages 3 to 6",
  inStock: true,
  isBestseller: true
},
{
  id: "p3",
  title: "Magical Creatures Coloring",
  subtitle: "Fantasy & Imagination | 60 Pages",
  category: "fantasy",
  price: 14.99,
  originalPrice: 19.99,
  rating: 4.8,
  reviews: 567,
  tag: "NEW",
  tagColor: "#C8B6E2",
  ageRange: "Ages 4–8",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fd32f24b-1767494495174.png",
  alt: "Magical creatures coloring book with unicorns dragons and fairy tale characters for children ages 4 to 8",
  inStock: true,
  isNew: true
},
{
  id: "p4",
  title: "Tracing & Writing Starter",
  subtitle: "Pencil Control + Letters | 64 Pages",
  category: "tracing",
  price: 9.99,
  originalPrice: 13.99,
  rating: 4.9,
  reviews: 934,
  tag: "POPULAR",
  tagColor: "#FFB5A7",
  ageRange: "Ages 3–5",
  image: "https://images.unsplash.com/photo-1631847560046-32bc5ae736e5",
  alt: "Letter and number tracing workbook for preschoolers developing pencil control and writing skills",
  inStock: true,
  isBestseller: true
},
{
  id: "p5",
  title: "Ocean World Coloring Set",
  subtitle: "Sea Life + Colors | 56 Pages",
  category: "coloring",
  price: 16.99,
  originalPrice: 22.99,
  rating: 4.7,
  reviews: 421,
  tag: "BUNDLE",
  tagColor: "#B8E0FF",
  ageRange: "Ages 4–8",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_19d5afcf1-1768513346420.png",
  alt: "Ocean world coloring book set featuring fish whales dolphins and underwater adventure scenes",
  inStock: true
},
{
  id: "p6",
  title: "Shapes & Colors Workbook",
  subtitle: "Early Geometry | 40 Pages",
  category: "numbers",
  price: 8.99,
  originalPrice: 12.99,
  rating: 4.8,
  reviews: 312,
  ageRange: "Ages 2–4",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1374ef849-1767076245644.png",
  alt: "Shapes and colors early learning workbook for toddlers with coloring and matching activities",
  inStock: true,
  isNew: true
},
{
  id: "p7",
  title: "Jungle Safari Coloring",
  subtitle: "Wild Animals | 52 Pages",
  category: "coloring",
  price: 11.99,
  originalPrice: 16.99,
  rating: 4.6,
  reviews: 278,
  ageRange: "Ages 3–6",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d85a61c5-1766519488274.png",
  alt: "Jungle safari coloring book with lions elephants giraffes and wild animal illustrations for children",
  inStock: true
},
{
  id: "p8",
  title: "My First Sight Words",
  subtitle: "Reading Readiness | 48 Pages",
  category: "alphabet",
  price: 13.99,
  originalPrice: 18.99,
  rating: 4.9,
  reviews: 689,
  ageRange: "Ages 4–6",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14479d843-1765950644054.png",
  alt: "Sight words reading readiness workbook for early readers aged 4 to 6 with tracing and coloring activities",
  inStock: true,
  isBestseller: true
},
{
  id: "p9",
  title: "24-Piece Colored Pencil Set",
  subtitle: "Premium Soft Core | Artist Quality",
  category: "accessories",
  price: 18.99,
  originalPrice: 24.99,
  rating: 4.9,
  reviews: 1456,
  tag: "BESTSELLER",
  tagColor: "#F4C842",
  ageRange: "Ages 4+",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1da814acf-1766818616630.png",
  alt: "24 piece premium colored pencil set with soft core for children's art and coloring books",
  inStock: true,
  isBestseller: true
},
{
  id: "p10",
  title: "Fairy Tales Coloring Book",
  subtitle: "Classic Stories | 68 Pages",
  category: "fantasy",
  price: 15.99,
  originalPrice: 21.99,
  rating: 4.8,
  reviews: 394,
  ageRange: "Ages 4–8",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b56a8d92-1767181350296.png",
  alt: "Fairy tales coloring book featuring Cinderella Snow White and classic storybook characters for children",
  inStock: true,
  isNew: true
},
{
  id: "p11",
  title: "ABC Flash Cards Set",
  subtitle: "26 Premium Laminated Cards",
  category: "accessories",
  price: 14.99,
  originalPrice: 19.99,
  rating: 4.7,
  reviews: 521,
  ageRange: "Ages 2–5",
  image: "https://images.unsplash.com/photo-1570387172753-17852ddb5b70",
  alt: "ABC alphabet flash cards set with 26 laminated cards featuring letters and illustrations for toddlers",
  inStock: true
},
{
  id: "p12",
  title: "Watercolor Paint Set",
  subtitle: "16 Colors + 2 Brushes",
  category: "accessories",
  price: 22.99,
  originalPrice: 29.99,
  rating: 4.8,
  reviews: 867,
  ageRange: "Ages 5+",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_127689efc-1769348351561.png",
  alt: "Watercolor paint set with 16 colors and 2 brushes for children's art projects and coloring books",
  inStock: false,
  tag: "COMING SOON",
  tagColor: "#C8B6E2"
},
{
  id: "p13",
  title: "The Cozy Coloring Book",
  subtitle: "Screen-Free Creativity & Calm | Cozy Illustrations",
  category: "coloring",
  price: 6.00,
  originalPrice: 6.00,
  rating: 4.9,
  reviews: 287,
  tag: "NEW",
  tagColor: "#C8B6E2",
  ageRange: "Ages 3–8",
  image: "/assets/images/71LSUa5gigL._SY385_-1771700471899.jpg",
  alt: "The Cozy Coloring Book featuring warm and comforting scenes for peaceful screen-free creative play and relaxation",
  inStock: true,
  isNew: true,
  purchaseLink: "https://www.amazon.com/Cozy-Coloring-Book-Vivian-Nantambi/dp/B0GKMZ5HLX/ref=sr_1_4?dib=eyJ2IjoiMSJ9.vVDkniSHjCesmoaTc0aYe2NgeYSPwg372Kbp8n8Qvs_EwSxlwphV_5vMTZefrW79iUXeim_z-fqkQEZhQ5rvoQIc3-_I2xythtQAQoX57-98i-SmqLF_XXAfHfT_yxW52k-GD2t21BmZ5l8DnM0ofo773y3Uem3sr2wGZeHLBPLmvfBEZiXXejDzwfpIGvzP-GjaW9L10m4s4bb8VVbdRLVVvseN8JopoPKGj65lCuQ.X_4M6beXRXpVpybDHvQB-ps_qdU40Xj5kRpw-pwqEeY&dib_tag=se&qid=1771697928&refinements=p_27%3AMy+Happy+Place&s=books&sr=1-4&text=My+Happy+Place"
}];


const DEFAULT_FILTERS: FilterState = {
  category: "all",
  ageRange: "all",
  priceRange: "all",
  sortBy: "featured"
};

export default function ProductsInteractive() {
  const [filters, setFilters] = useState<FilterState>(DEFAULT_FILTERS);
  const [searchQuery, setSearchQuery] = useState("");

  const handleFilterChange = (key: keyof FilterState, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleReset = () => {
    setFilters(DEFAULT_FILTERS);
    setSearchQuery("");
  };

  const filteredProducts = useMemo(() => {
    let result = [...ALL_PRODUCTS];

    // Search
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (p) =>
        p.title.toLowerCase().includes(q) ||
        p.subtitle.toLowerCase().includes(q) ||
        p.category.toLowerCase().includes(q)
      );
    }

    // Category
    if (filters.category !== "all") {
      result = result.filter((p) => p.category === filters.category);
    }

    // Age range
    if (filters.ageRange !== "all") {
      result = result.filter((p) => {
        const age = p.ageRange.toLowerCase();
        const filterAge = filters.ageRange;
        if (filterAge === "2-4") return age.includes("2") || age.includes("3") || age.includes("4");
        if (filterAge === "3-6") return age.includes("3") || age.includes("4") || age.includes("5") || age.includes("6");
        if (filterAge === "4-8") return age.includes("4") || age.includes("5") || age.includes("6") || age.includes("7") || age.includes("8");
        if (filterAge === "6-10") return age.includes("6") || age.includes("7") || age.includes("8") || age.includes("9") || age.includes("10");
        return true;
      });
    }

    // Price range
    if (filters.priceRange !== "all") {
      result = result.filter((p) => {
        if (filters.priceRange === "0-10") return p.price < 10;
        if (filters.priceRange === "10-15") return p.price >= 10 && p.price <= 15;
        if (filters.priceRange === "15-25") return p.price > 15 && p.price <= 25;
        if (filters.priceRange === "25+") return p.price > 25;
        return true;
      });
    }

    // Sort
    switch (filters.sortBy) {
      case "newest":
        result = result.filter((p) => p.isNew).concat(result.filter((p) => !p.isNew));
        break;
      case "price-asc":
        result.sort((a, b) => a.price - b.price);
        break;
      case "price-desc":
        result.sort((a, b) => b.price - a.price);
        break;
      case "rating":
        result.sort((a, b) => b.rating - a.rating);
        break;
      case "bestselling":
        result = result.filter((p) => p.isBestseller).concat(result.filter((p) => !p.isBestseller));
        break;
      default:
        break;
    }

    return result;
  }, [filters, searchQuery]);

  return (
    <>
      <ProductsHeader
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        totalCount={ALL_PRODUCTS.length} />
      

      <div className="max-w-7xl mx-auto px-6 py-10">
        {/* Bundle banner */}
        <BundleBanner />

        {/* Main layout */}
        <div className="flex flex-col lg:flex-row gap-8">
          <FilterSidebar
            filters={filters}
            onFilterChange={handleFilterChange}
            onReset={handleReset}
            productCount={filteredProducts.length} />
          
          <div className="flex-1 min-w-0">
            {/* Mobile filter chips */}
            <div className="flex gap-2 overflow-x-auto pb-3 mb-5 lg:hidden" style={{ scrollbarWidth: "none" }}>
              {["all", "alphabet", "numbers", "coloring", "tracing", "fantasy", "accessories"].map((cat) =>
              <button
                key={cat}
                onClick={() => handleFilterChange("category", cat)}
                className={`filter-chip shrink-0 capitalize ${filters.category === cat ? "active" : ""}`}>
                
                  {cat === "all" ? "All" : cat}
                </button>
              )}
            </div>

            <ProductGrid products={filteredProducts} />
          </div>
        </div>
      </div>

      {/* WhatsApp floating button */}
      <a
        href="https://wa.me/256764590167"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 hover:scale-110 active:scale-95 group"
        aria-label="Chat on WhatsApp"
      >
        <svg
          className="w-7 h-7"
          fill="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
        </svg>
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse"></span>
      </a>
    </>
  );
}